import axios from "../../../../axios-order";
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import State from "../../../../asserts/jsonData/state.json";
import { toast } from "react-toastify";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { Grid, Stack, Typography, Box, styled, Button, Chip, Dialog, DialogTitle, DialogContent, DialogActions, TextField, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import SelectInput from "../../../../components/ui/basicSelectInput";
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Check } from "@mui/icons-material";
import AssignmentIcon from '@mui/icons-material/Assignment';
import BallotIcon from '@mui/icons-material/Ballot';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';
import excelIconImage from '../../../../asserts/images/excelicon.svg';
import BoxWrapper from "../../../../components/ui/boxWrapper";

// Custom SVG Icons
const CheckIcon = ({ size = 16, color = "#ffffff" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20,6 9,17 4,12"></polyline>
    </svg>
);

const ChevronRightIcon = ({ size = 20, color = "#2563eb" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="9,18 15,12 9,6"></polyline>
    </svg>
);

// Custom step icon component
const CustomStepIconRoot = styled('div')(({ theme }) => ({
    color: '#ccc',
    display: 'flex',
    height: 34,
    width: 34,
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    fontWeight: '500',
    borderRadius: '50%',
    backgroundColor: '#ccc',
    variants: [
        {
            props: ({ ownerState }) => ownerState.active,
            style: {
                backgroundColor: '#1976d2',
                color: '#fff',
                backgroundImage: 'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
                boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
            },
        },
        {
            props: ({ ownerState }) => ownerState.completed,
            style: {
                backgroundColor: '#4caf50',
                color: '#fff',
            },
        },
    ],
}));

const Form24QFiling = () => {
    const history = useHistory();
    const [activeStep, setActiveStep] = useState(0);
    const [completedSteps, setCompletedSteps] = useState(new Set());
    const [errors, setErrors] = useState({});
    const [activeFormStep, setActiveFormStep] = useState(0);
    const steps = ['Form 24Q Details', 'Challan Details', 'Annexure 1'];

    const [challanData, setChallanData] = useState([]);
    const [annexureData, setAnnexureData] = useState([]);
    const [pageSize, setPageSize] = useState(50);
    const [isEdit, setIsEdit] = useState(0);
    const [taxDeductorData, setTaxDeductorData] = useState({});
    const [fileName, setFileName] = useState("");
    const [CSIfile, setCSIfile] = useState();
    const [isFUVGenerating, setIsFUVGenerating] = useState(false);
    const [autoDownloadOpen, setAutoDownloadOpen] = useState(false);
    const [autoDownloadPhone, setAutoDownloadPhone] = useState('');
    const [isSendingOtp, setIsSendingOtp] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [otpValue, setOtpValue] = useState('');
    const [isSubmittingOtp, setIsSubmittingOtp] = useState(false);
    const [otpReferenceId, setOtpReferenceId] = useState('');
    const [autoDownloadBusinessEntityId, setAutoDownloadBusinessEntityId] = useState('');
    const [isDownloadingCSI, setIsDownloadingCSI] = useState(false);
    const [isViewOnly, setIsViewOnly] = useState(false);
    const [savedYesPan, setSavedYesPan] = useState('');
    const [savedYesDesignation, setSavedYesDesignation] = useState('');
    // Form Data States
    const [employerDetailFormData, setEmployerDetailFormData] = useState({
        quarter: localStorage.getItem('quarter_24Q'),
        tan: '',
        last_tan: '',
        financial_year: localStorage.getItem('financial_year_24Q'),
        assessment_year: '',
        pan: '',
        type_of_deductor: '',
        is_revised_return: false,
        last_deductor_type: '',
        update_deductor_details: '',
        receipt_number_original: '',
        receipt_number_previous: '',
    });

    const [taxDeductionFormData, setTaxDeductionFormData] = useState({
        name: '',
        ministry_department_name: '',
        ministry_department_name_other: '',
        branch_division: '',
        state_name: null,
        ddo_code: '',
        pao_code: '',
        ddo_registration_number: '',
        pao_registration_number: '',
        flat_no: '',
        premises_name: '',
        road_or_street: '',
        area_or_location: '',
        town_or_city: '',
        pin_code: '',
        state: null,
        telephone_no: '',
        telephone_alternative: '',
        email: '',
        email_alternative: '',
        gstn: '',
        has_address_changed: false,
        ao_ain: '',
    });

    const [personFormData, setPersonFormData] = useState({
        responsible_name: '',
        responsible_pan: '',
        responsible_designation: '',
        responsible_flat_no: '',
        responsible_premises_name: '',
        responsible_road_or_street: '',
        responsible_area_or_location: '',
        responsible_town_or_city: '',
        responsible_pin_code: '',
        responsible_state: null,
        responsible_telephone_no: '',
        responsible_telephone_alternative: '',
        responsible_mobile_no: '',
        responsible_email: '',
        responsible_email_alternative: '',
        responsible_address_same: true,
        responsible_address_changed: false,
        responsible_receipt_number: '',
        filed_earlier_period: false,
        previous_statement_number: ''
    });

    const [sameAddressFormData, setSameAddressFormData] = useState({
        responsible_pan: '',
        responsible_designation: '',
        same_as_prev_data: ''
    });

    const [draftScreens, setDraftScreens] = useState({
        draft_screen_1: null,
        draft_screen_2: null,
        draft_screen_3: null
    });

    const [previousData, setPreviousdata] = useState({});

    useEffect(() => {
        // getBusinessEntityDetails().then(() => {
        getForm24QData();
        // });
    }, []);

    useEffect(() => {
        ValidatorForm.addValidationRule('isPANDifferent', (value) => {
            // if (personFormData.responsible_address_same === true) {
            //     return true;
            // }
            if (value && employerDetailFormData.pan) {
                return value.toUpperCase() !== employerDetailFormData.pan.toUpperCase();
            }
            return true;
        });

        return () => {
            ValidatorForm.removeValidationRule('isPANDifferent');
        };
    }, [employerDetailFormData.pan, personFormData.responsible_address_same]);

    useEffect(() => {
        if (activeStep === 2) {
            console.log("📍 Entered FormStep2");
            console.log("responsible_address_same:", personFormData.responsible_address_same);
            console.log("Current savedYesPan:", savedYesPan);
            console.log("Current savedYesDesignation:", savedYesDesignation);

            // When entering FormStep2, if responsible_address_same is true (default)
            // Copy data from FormStep1 (taxDeductionFormData)
            if (personFormData.responsible_address_same === true) {
                const shouldUpdatePan = !savedYesPan || savedYesPan === '';
                const shouldUpdateDesignation = !savedYesDesignation || savedYesDesignation === '';

                console.log("Should update PAN?", shouldUpdatePan);
                console.log("Should update Designation?", shouldUpdateDesignation);

                let YesPan = sameAddressFormData.responsible_pan;
                let YesDesignation = sameAddressFormData.responsible_designation;
                if (sameAddressFormData.same_as_prev_data === 'No') {
                    YesPan = '';
                    YesDesignation = '';
                }

                setPersonFormData(prev => ({
                    ...prev,
                    // ✅ FIX: Preserve edited values for all fields
                    responsible_name: prev.responsible_name || taxDeductionFormData.name,
                    responsible_flat_no: prev.responsible_flat_no || taxDeductionFormData.flat_no,
                    responsible_premises_name: prev.responsible_premises_name || taxDeductionFormData.premises_name,
                    responsible_road_or_street: prev.responsible_road_or_street || taxDeductionFormData.road_or_street,
                    responsible_area_or_location: prev.responsible_area_or_location || taxDeductionFormData.area_or_location,
                    responsible_town_or_city: prev.responsible_town_or_city || taxDeductionFormData.town_or_city,
                    responsible_pin_code: prev.responsible_pin_code || taxDeductionFormData.pin_code,
                    responsible_state: prev.responsible_state || taxDeductionFormData.state,
                    responsible_telephone_no: prev.responsible_telephone_no || taxDeductionFormData.telephone_no,
                    responsible_telephone_alternative: prev.responsible_telephone_alternative || taxDeductionFormData.telephone_alternative,
                    responsible_email: prev.responsible_email || taxDeductionFormData.email,
                    responsible_email_alternative: prev.responsible_email_alternative || taxDeductionFormData.email_alternative,
                    responsible_mobile_no: prev.responsible_mobile_no || '',
                    // ✅ CRITICAL: PAN and Designation use cached values (special handling)
                    responsible_pan: YesPan,
                    responsible_designation: YesDesignation,
                }));

                console.log("✅ Updated form - PAN:", YesPan);
                console.log("✅ Updated form - Designation:", YesDesignation);
            }
        }
    }, [activeStep, taxDeductionFormData, personFormData.responsible_address_same]);


    const getCombinedChallanDetails = () => {
        const payload = {
            business_entity_id: localStorage.getItem('business_entity_id'),
            financial_year: localStorage.getItem('financial_year_24Q'),
            quarter: localStorage.getItem('quarter_24Q')
        };

        axios.post('/get_tds_24q_rpu_annexure_data', payload)
            .then((res) => {
                if (res.data.status) {
                    setChallanData(res.data.rpu_data || []);
                    setAnnexureData(res.data.annexure1_data || []);
                }
            })
            .catch((err) => {
                console.error("Error fetching combined challan details:", err);
            });
    };

    const getForm24QData = () => {
        const payload = {
            business_entity_id: localStorage.getItem('business_entity_id'),
            financial_year: localStorage.getItem('financial_year_24Q'),
            quarter: localStorage.getItem('quarter_24Q')
        };
        axios.post(`/get_form24q_details`, payload)
            .then((res) => {
                if (res.data.status === true) {
                    checkFilingStatus();
                    setIsEdit(res.data.data.id);
                    localStorage.setItem('form24q_id', res.data.data.id);

                    // Set draft screen values from API response
                    setDraftScreens({
                        draft_screen_1: res.data.data.draft_screen_1,
                        draft_screen_2: res.data.data.draft_screen_2,
                        draft_screen_3: res.data.data.draft_screen_3
                    });
                    setPreviousdata(res.data.data.same_as_prev_data)
                    console.log("263---------", res.data.data.same_as_prev_data);

                    // Determine deductor type from PAN
                    let deductorType = '';
                    if (res.data.data.pan) {
                        const fourthChar2 = res.data.data.pan.charAt(3);
                        if (fourthChar2 === 'C') {
                            deductorType = "Company";
                        } else if (fourthChar2 === 'B') {
                            deductorType = "Body of Individuals";
                        } else if (fourthChar2 === 'F') {
                            deductorType = "Firm";
                        } else if (fourthChar2 === 'P' || fourthChar2 === 'H') {
                            deductorType = "Individual/HUF";
                        }
                    }

                    const assessmentYear = calculateAssessmentYearFull(res.data.data.financial_year);
                    console.log("AY--->", assessmentYear);

                    setEmployerDetailFormData(prevFormData => ({
                        ...prevFormData,
                        quarter: localStorage.getItem('quarter_24Q'),
                        tan: res.data.data.tan || '',
                        last_tan: res.data.data.last_tan || '',
                        financial_year: res.data.data.financial_year || localStorage.getItem('financial_year_24Q'),
                        assessment_year: res.data.data.assessment_year || assessmentYear,
                        pan: res.data.data.pan || '',
                        type_of_deductor: res.data.data.type_of_deductor || deductorType,
                        is_revised_return: res.data.data.is_revised_return || false,
                        last_deductor_type: res.data.data.last_deductor_type || '',
                        update_deductor_details: res.data.data.update_deductor_details || '',
                        receipt_number_original: res.data.data.receipt_number_original || '',
                        receipt_number_previous: res.data.data.receipt_number_previous || '',
                    }));

                    setTaxDeductionFormData(prevFormData => ({
                        ...prevFormData,
                        name: res.data.data.name || '',
                        ministry_department_name: res.data.data.ministry_department_name || '',
                        ministry_department_name_other: res.data.data.ministry_department_name_other || '',
                        branch_division: res.data.data.branch_division || '',
                        state_name: res.data.data.state_name || '',
                        ddo_code: res.data.data.ddo_code || '',
                        pao_code: res.data.data.pao_code || '',
                        ddo_registration_number: res.data.data.ddo_registration_number || '',
                        pao_registration_number: res.data.data.pao_registration_number || '',
                        flat_no: res.data.data.flat_no || '',
                        premises_name: res.data.data.premises_name || '',
                        road_or_street: res.data.data.road_or_street || '',
                        area_or_location: res.data.data.area_or_location || '',
                        town_or_city: res.data.data.town_or_city || '',
                        pin_code: res.data.data.pin_code || '',
                        state: res.data.data.state ? res.data.data.state.toUpperCase() : '',
                        telephone_no: res.data.data.telephone_no || '',
                        telephone_alternative: res.data.data.telephone_alternative || '',
                        email: res.data.data.email || '',
                        email_alternative: res.data.data.email_alternative || '',
                        gstn: res.data.data.gstn || localStorage.getItem('gst') || '',
                        has_address_changed: res.data.data.has_address_changed || false,
                        ao_ain: res.data.data.ao_ain || ''
                    }));

                    setPersonFormData(prevFormData => ({
                        ...prevFormData,
                        responsible_name: res.data.data.responsible_name || '',
                        responsible_pan: res.data.data.responsible_pan || '',
                        responsible_designation: res.data.data.responsible_designation || '',
                        responsible_flat_no: res.data.data.responsible_flat_no || '',
                        responsible_premises_name: res.data.data.responsible_premises_name || '',
                        responsible_road_or_street: res.data.data.responsible_road_or_street || '',
                        responsible_area_or_location: res.data.data.responsible_area_or_location || '',
                        responsible_town_or_city: res.data.data.responsible_town_or_city || '',
                        responsible_pin_code: res.data.data.responsible_pin_code || '',
                        responsible_state: res.data.data.responsible_state || '',
                        responsible_telephone_no: res.data.data.responsible_telephone_no || '',
                        responsible_telephone_alternative: res.data.data.responsible_telephone_alternative || '',
                        responsible_mobile_no: res.data.data.responsible_mobile_no || '',
                        responsible_email: res.data.data.responsible_email || '',
                        responsible_email_alternative: res.data.data.responsible_email_alternative || '',
                        responsible_address_same: res.data.data.responsible_address_same !== undefined
                            ? res.data.data.responsible_address_same
                            : true,
                        responsible_address_changed: res.data.data.responsible_address_changed || false,
                        responsible_receipt_number: res.data.data.responsible_receipt_number || false,
                        filed_earlier_period: res.data.data.filed_earlier_period || false,
                        previous_statement_number: res.data.data.previous_statement_number || '',
                    }));

                    // ✅✅✅ CRITICAL: Initialize YES cache immediately after setPersonFormData ✅✅✅
                    console.log("🎯🎯🎯 INITIALIZING YES CACHE ON PAGE LOAD");
                    console.log("same_as_prev_data:", res.data.data.same_as_prev_data);
                    console.log("responsible_address_same:", res.data.data.responsible_address_same);
                    console.log("PAN from backend:", res.data.data.responsible_pan);
                    console.log("Designation from backend:", res.data.data.responsible_designation);

                    // Initialize the YES cache with values from backend
                    setSavedYesPan(res.data.data.responsible_pan || '');
                    setSavedYesDesignation(res.data.data.responsible_designation || '');

                    console.log("✅ YES cache initialized:");
                    console.log("  - savedYesPan:", res.data.data.responsible_pan || '');
                    console.log("  - savedYesDesignation:", res.data.data.responsible_designation || '');

                    setSameAddressFormData(sameAddressFormData => ({
                        responsible_pan: res.data.data.responsible_pan || '',
                        responsible_designation: res.data.data.responsible_designation || '',
                        same_as_prev_data: res.data.data.same_as_prev_data || '',
                    }));

                    console.log("Responsible Pan ==>" + res.data.data.responsible_pan);

                    setFileName(res.data.data.csi_file_name || '');
                    if (res.data.data.csi_file_data) {
                        const fileData = res.data.data.csi_file_data.startsWith('data:')
                            ? res.data.data.csi_file_data
                            : `data:application/octet-stream;base64,${res.data.data.csi_file_data}`;
                        setCSIfile(fileData);
                    } else {
                        setCSIfile('');
                    }
                } else {
                    getBusinessEntityDetails().then((deductorData) => {
                        if (deductorData) {
                            updateTaxDeductorData(deductorData);
                        }
                    });
                }
            })
            .catch((err) => {
                console.error("Error fetching form 24Q data:", err);
            });
    };

    const checkFilingStatus = () => {
        axios
            .get(`/get_24q_filing_data/${localStorage.getItem("business_entity_id")}`)
            .then((res) => {
                const currentRecord = res?.data?.records?.find(
                    record =>
                        record.financial_year === localStorage.getItem('financial_year_24Q') &&
                        record.quarter === localStorage.getItem('quarter_24Q') &&
                        record.status.toLowerCase() === 'succeeded'
                );

                if (currentRecord) {
                    setIsViewOnly(true);
                }
            })
            .catch((err) => {
                console.error("Error checking filing status:", err);
            });
    };

    const updateTaxDeductorData = (deductorData) => {
        let deductorType = '';
        if (deductorData.particulars_of_statement?.pan) {
            const fourthChar2 = deductorData.particulars_of_statement.pan.charAt(3);
            if (fourthChar2 === 'C') {
                deductorType = "Company";
            } else if (fourthChar2 === 'B') {
                deductorType = "Body of Individuals";
            } else if (fourthChar2 === 'F') {
                deductorType = "Firm";
            } else if (fourthChar2 === 'P' || fourthChar2 === 'H') {
                deductorType = "Individual/HUF";
            }
        }

        setEmployerDetailFormData(prevFormData => ({
            ...prevFormData,
            quarter: localStorage.getItem('quarter_24Q'),
            tan: deductorData.particulars_of_statement?.tan || '',
            financial_year: localStorage.getItem('financial_year_24Q'),
            assessment_year: calculateAssessmentYearFull(localStorage.getItem('financial_year_24Q')),
            pan: deductorData.particulars_of_statement?.pan || '',
            type_of_deductor: deductorData.particulars_of_statement?.type_of_deductor || deductorType,
        }));

        setTaxDeductionFormData(prevFormData => ({
            ...prevFormData,
            name: deductorData.particulars_of_deductor?.name || '',
            email: deductorData.particulars_of_deductor?.email || '',
            telephone_no: deductorData.particulars_of_deductor?.contact_number || '',
            flat_no: deductorData.particulars_of_deductor?.flat_no || '',
            premises_name: deductorData.particulars_of_deductor?.premises_name || '',
            road_or_street: deductorData.particulars_of_deductor?.road_street_name || '',
            area_or_location: deductorData.particulars_of_deductor?.area || '',
            town_or_city: deductorData.particulars_of_deductor?.city || '',
            pin_code: deductorData.particulars_of_deductor?.pincode || '',
            state: deductorData.particulars_of_deductor?.state?.toUpperCase() || '',
            gstn: localStorage.getItem('gst') || '',
        }));

        // setTaxDeductionFormData(prevFormData => ({
        //     ...prevFormData,
        //     name: deductorData.particulars_of_deductor?.name || '',
        //     email: deductorData.particulars_of_deductor?.email || '',
        //     telephone_no: deductorData.particulars_of_deductor?.contact_number || '',
        //     gstn: localStorage.getItem('gst') || '',
        // }));

        setPersonFormData(prevFormData => ({
            ...prevFormData,
            responsible_name: deductorData.particulars_person_responsible_for_deduction?.name || '',
            // responsible_pan: deductorData.particulars_person_responsible_for_deduction?.pan || '',
            responsible_flat_no: deductorData.particulars_person_responsible_for_deduction?.flat_no || '',
            responsible_premises_name: deductorData.particulars_person_responsible_for_deduction?.premises_name || '',
            responsible_road_or_street: deductorData.particulars_person_responsible_for_deduction?.road_or_street || '',
            responsible_area_or_location: deductorData.particulars_person_responsible_for_deduction?.area_or_location || '',
            responsible_town_or_city: deductorData.particulars_person_responsible_for_deduction?.town_or_city || '',
            responsible_pin_code: deductorData.particulars_person_responsible_for_deduction?.pin_code || '',
            responsible_state: deductorData.particulars_person_responsible_for_deduction?.state,
            responsible_telephone_no: deductorData.particulars_person_responsible_for_deduction?.telephone_primary || '',
            responsible_telephone_alternative: deductorData.particulars_person_responsible_for_deduction?.telephone_alternative || '',
            responsible_mobile_no: deductorData.particulars_person_responsible_for_deduction?.mobile_no || '',
            responsible_email: deductorData.particulars_person_responsible_for_deduction?.email || '',
            responsible_email_alternative: deductorData.particulars_person_responsible_for_deduction?.email_alternative || '',
        }));
    };

    const getBusinessEntityDetails = () => {
        return axios.get(`/get_form26q_initial_form_data/${localStorage.getItem("business_entity_id")}`)
            .then((res) => {
                if (res?.data?.status) {
                    const deductorData = res.data.data;
                    setTaxDeductorData(deductorData);
                    updateTaxDeductorData(deductorData);
                    return deductorData;
                }
            })
            .catch((err) => {
                console.error("Error fetching business entity details:", err);
            });
    };

    const validateTypeOfDeductor = () => {
        if (!employerDetailFormData.type_of_deductor || employerDetailFormData.type_of_deductor.trim() === '') {
            setErrors(prev => ({
                ...prev,
                type_of_deductor: 'Type of Deductor is required'
            }));
            return false;
        }
        return true;
    };

    const handleChange = (e) => {
        if (e) {
            const { name, value } = e.target;
            if (name === 'financial_year') {
                const assessmentYear = calculateAssessmentYearFull(value);
                console.log("AY--->", assessmentYear);

                setEmployerDetailFormData({
                    ...employerDetailFormData,
                    [name]: value,
                    assessment_year: assessmentYear
                });
            } else if (name === "is_revised_return") {
                const val = value === 1 ? true : false;
                setEmployerDetailFormData({
                    ...employerDetailFormData,
                    is_revised_return: val
                });
            } else {
                setEmployerDetailFormData({ ...employerDetailFormData, [name]: value });
            }

            if (errors[name]) {
                setErrors(prev => ({
                    ...prev,
                    [name]: ''
                }));
            }
        }
    };

    const calculateAssessmentYearFull = (financialYear) => {
        const startYear = parseInt(financialYear.split('-')[0]);
        const assessmentStartYear = startYear + 1;
        const assessmentEndYear = startYear + 2;
        return `${assessmentStartYear}-${assessmentEndYear}`;
    };

    const handleEmployerChange = (e) => {
        if (e) {
            const { name, value } = e.target;
            if (name === "has_address_changed") {
                const val = value === 1 ? true : false;
                setTaxDeductionFormData({
                    ...taxDeductionFormData,
                    has_address_changed: val,
                });
            } else {
                setTaxDeductionFormData({ ...taxDeductionFormData, [name]: value });
            }

            if (errors[name]) {
                setErrors(prev => ({
                    ...prev,
                    [name]: ''
                }));
            }
        }
    };

    const handleDeductorChange = (e) => {
        if (e) {
            const { name, value } = e.target;

            if (name === "responsible_address_same") {
                console.log("=== DROPDOWN CHANGED ===");
                console.log("Selected value:", value === 1 ? "Yes" : "No");

                if (value === 2) { // Switching to NO
                    console.log("--- Switching to NO ---");

                    // Save current YES values BEFORE switching
                    const currentPan = personFormData.responsible_pan || '';
                    const currentDesignation = personFormData.responsible_designation || '';

                    console.log("💾 SAVING YES VALUES:");
                    console.log("  - PAN:", currentPan);
                    console.log("  - Designation:", currentDesignation);

                    setSavedYesPan(currentPan);
                    setSavedYesDesignation(currentDesignation);

                    const responsiblePersonData = taxDeductorData.particulars_person_responsible_for_deduction;
                    const isResponsiblePersonEmpty = !responsiblePersonData || Object.keys(responsiblePersonData).length === 0;

                    if (isResponsiblePersonEmpty) {
                        toast.warning('Please add the deduction person data in business entity details', {
                            autoClose: 3000,
                            progress: 0,
                        });

                        setPersonFormData({
                            ...personFormData,
                            responsible_name: '',
                            responsible_pan: '',
                            responsible_flat_no: '',
                            responsible_premises_name: '',
                            responsible_road_or_street: '',
                            responsible_area_or_location: '',
                            responsible_town_or_city: '',
                            responsible_pin_code: '',
                            responsible_state: null,
                            responsible_telephone_no: '',
                            responsible_telephone_alternative: '',
                            responsible_email: '',
                            responsible_email_alternative: '',
                            responsible_mobile_no: '',
                            responsible_designation: '',
                            responsible_address_same: false
                        });
                    } else {
                        setPersonFormData({
                            ...personFormData,
                            responsible_name: responsiblePersonData.name || '',
                            responsible_pan: responsiblePersonData.pan || '',
                            responsible_flat_no: responsiblePersonData.flat_no || '',
                            responsible_premises_name: responsiblePersonData.premises_name || '',
                            responsible_road_or_street: responsiblePersonData.road_or_street || '',
                            responsible_area_or_location: responsiblePersonData.area_or_location || '',
                            responsible_town_or_city: responsiblePersonData.town_or_city || '',
                            responsible_pin_code: responsiblePersonData.pin_code || '',
                            responsible_state: responsiblePersonData.state || null,
                            responsible_telephone_no: responsiblePersonData.telephone_primary || '',
                            responsible_telephone_alternative: responsiblePersonData.telephone_alternative || '',
                            responsible_email: responsiblePersonData.email || '',
                            responsible_email_alternative: responsiblePersonData.email_alternative || '',
                            responsible_mobile_no: responsiblePersonData.mobile_no || '',
                            responsible_designation: responsiblePersonData.designation || '',
                            responsible_address_same: false
                        });
                    }
                } else { // Switching to YES
                    console.log("--- Switching to YES ---");
                    console.log("📦 Cached PAN:" + sameAddressFormData.responsible_pan, " " + sameAddressFormData.same_as_prev_data);
                    console.log("📦 Cached Designation:", savedYesDesignation);
                    let YesPan = sameAddressFormData.responsible_pan;
                    let YesDesignation = sameAddressFormData.responsible_designation;
                    if (sameAddressFormData.same_as_prev_data === 'No') {
                        YesPan = '';
                        YesDesignation = '';
                    }
                    console.log("Updated Pan ==>" + YesPan);

                    // ✅ CRITICAL: Build the complete new state object with all fields
                    const newPersonFormData = {
                        responsible_name: taxDeductionFormData.name || '',
                        responsible_pan: YesPan,
                        responsible_designation: YesDesignation,
                        responsible_flat_no: taxDeductionFormData.flat_no || '',
                        responsible_premises_name: taxDeductionFormData.premises_name || '',
                        responsible_road_or_street: taxDeductionFormData.road_or_street || '',
                        responsible_area_or_location: taxDeductionFormData.area_or_location || '',
                        responsible_town_or_city: taxDeductionFormData.town_or_city || '',
                        responsible_pin_code: taxDeductionFormData.pin_code || '',
                        responsible_state: taxDeductionFormData.state || null,
                        responsible_telephone_no: taxDeductionFormData.telephone_no || '',
                        responsible_telephone_alternative: taxDeductionFormData.telephone_alternative || '',
                        responsible_email: taxDeductionFormData.email || '',
                        responsible_email_alternative: taxDeductionFormData.email_alternative || '',
                        responsible_mobile_no: '',
                        responsible_address_same: true,
                        responsible_address_changed: personFormData.responsible_address_changed,
                        responsible_receipt_number: personFormData.responsible_receipt_number,
                        filed_earlier_period: personFormData.filed_earlier_period,
                        previous_statement_number: personFormData.previous_statement_number
                    };

                    console.log("✅ Setting form with PAN:", newPersonFormData.responsible_pan);
                    console.log("✅ Setting form with Designation:", newPersonFormData.responsible_designation);

                    setPersonFormData(newPersonFormData);
                }
            } else if (name === "responsible_address_changed" || name === "responsible_receipt_number" || name === "filed_earlier_period") {
                const val = value === 1 ? true : false;
                setPersonFormData({
                    ...personFormData,
                    [name]: val
                });
            } else {
                // Update form data
                setPersonFormData({ ...personFormData, [name]: value });

                // Update YES cache in real-time when in YES mode
                if (personFormData.responsible_address_same === true) {
                    if (name === "responsible_pan") {
                        console.log("🔄 Updating YES PAN cache to:", value);
                        setSavedYesPan(value);
                    }
                    if (name === "responsible_designation") {
                        console.log("🔄 Updating YES Designation cache to:", value);
                        setSavedYesDesignation(value);
                    }
                }

                // PAN validation
                if (name === "responsible_pan" && value && employerDetailFormData.pan) {
                    if (value.toUpperCase() === employerDetailFormData.pan.toUpperCase()) {
                        setErrors(prev => ({
                            ...prev,
                            responsible_pan: 'Responsible person PAN cannot be same as Deductor PAN'
                        }));
                    } else {
                        setErrors(prev => {
                            const newErrors = { ...prev };
                            delete newErrors.responsible_pan;
                            return newErrors;
                        });
                    }
                }
            }

            if (errors[name] && name !== "responsible_pan") {
                setErrors(prev => ({
                    ...prev,
                    [name]: ''
                }));
            }
        }
    };

    const handleFormDetailsBack = () => {
        console.log("Active Step ==>" + activeStep);
        if (activeStep === 0) {
            history.goBack();
            return;
        }
        setActiveStep(Math.max(0, activeStep - 1));
    };

    const handleFormDetailSubmit = async () => {
        if (activeStep === 0) {
            const currentAssessmentYear = calculateAssessmentYearFull(employerDetailFormData.financial_year);
            const payload = {
                ...employerDetailFormData,
                assessment_year: currentAssessmentYear,
                ...taxDeductionFormData,
                ...personFormData,
                business_entity_id: localStorage.getItem('business_entity_id'),
                csi_file_data: CSIfile,
                csi_file_name: fileName,
                same_as_prev_data: (draftScreens.draft_screen_1 === null && draftScreens.draft_screen_2 === null && draftScreens.draft_screen_3 === null)
                    ? null
                    : previousData || null,
                draft_screen_1: "yes"
            };

            let url = "/create_form_24q";
            if (draftScreens.draft_screen_1 === "yes") {
                url = "/update_form_24q";
                const form24qId = localStorage.getItem('form24q_id');
                if (form24qId) {
                    payload.id = parseInt(form24qId);
                }
            }

            try {
                const response = await axios.post(url, payload);

                if (response?.data?.data?.id) {
                    const newId = response.data.data.id;
                    setIsEdit(newId);
                    localStorage.setItem('form24q_id', newId);
                }

                await getForm24QData();

                toast.success('Data saved successfully');
            } catch (error) {
                console.error('Error saving Form 24Q:', error);
                toast.error('Failed to save data', {
                    autoClose: 3000,
                    progress: 0,
                });
                return;
            }

        }
        if (activeStep === 1) {
            await getBusinessEntityDetails();
            const payload = {
                ...employerDetailFormData,
                ...taxDeductionFormData,
                ...personFormData,
                business_entity_id: localStorage.getItem('business_entity_id'),
                csi_file_data: CSIfile,
                csi_file_name: fileName,
                same_as_prev_data: (draftScreens.draft_screen_1 === null && draftScreens.draft_screen_2 === null && draftScreens.draft_screen_3 === null)
                    ? null
                    : previousData || null,
                draft_screen_1: "yes",
                draft_screen_2: "yes"
            };

            const form24qId = localStorage.getItem('form24q_id') || isEdit;
            if (form24qId) {
                payload.id = parseInt(form24qId);
            }

            let url = "/update_form_24q";

            try {
                const response = await axios.post(url, payload);
                await getForm24QData();
                toast.success('Data saved successfully', {
                    autoClose: 3000,
                    progress: 0,
                });
            } catch (error) {
                console.error('Error in FormStep1 Continue:', error);
                toast.error('Failed to update data', {
                    autoClose: 3000,
                    progress: 0,
                });
                return;
            }
        }

        setCompletedSteps(prev => new Set(prev).add(activeStep));

        // ✅ ADD THIS: When moving from Step 1 to Step 2 with YES selected
        if (activeStep === 1 && personFormData.responsible_address_same === true) {
            console.log("🔄 Moving from Step 1 to Step 2 in YES mode");
            console.log("Will copy address from Step 1");
            console.log("Will use cached PAN:", savedYesPan);
            console.log("Will use cached Designation:", savedYesDesignation);

            // Update person form with Step 1 address data + cached YES values
            setPersonFormData(prev => ({
                ...prev,
                responsible_name: taxDeductionFormData.name || prev.responsible_name,
                responsible_flat_no: taxDeductionFormData.flat_no || prev.responsible_flat_no,
                responsible_premises_name: taxDeductionFormData.premises_name || prev.responsible_premises_name,
                responsible_road_or_street: taxDeductionFormData.road_or_street || prev.responsible_road_or_street,
                responsible_area_or_location: taxDeductionFormData.area_or_location || prev.responsible_area_or_location,
                responsible_town_or_city: taxDeductionFormData.town_or_city || prev.responsible_town_or_city,
                responsible_pin_code: taxDeductionFormData.pin_code || prev.responsible_pin_code,
                responsible_state: taxDeductionFormData.state || prev.responsible_state,
                responsible_telephone_no: taxDeductionFormData.telephone_no || prev.responsible_telephone_no,
                responsible_telephone_alternative: taxDeductionFormData.telephone_alternative || prev.responsible_telephone_alternative,
                responsible_email: taxDeductionFormData.email || prev.responsible_email,
                responsible_email_alternative: taxDeductionFormData.email_alternative || prev.responsible_email_alternative,
                responsible_mobile_no: '',
                // Keep cached YES values
                responsible_pan: savedYesPan || prev.responsible_pan,
                responsible_designation: savedYesDesignation || prev.responsible_designation,
            }));
        }

        if (activeStep < formSteps.length - 1) {
            setActiveStep(activeStep + 1);
        }
    };

    const fileUploader = (event) => {
        if (event.target.files[0]) {
            const file_data = event.target.files[0];
            let fileName = file_data.name;
            setFileName(fileName);
            const reader = new FileReader();
            reader.readAsDataURL(file_data);
            reader.onload = function () {
                let file_value = reader.result;
                setCSIfile(file_value);
            };
            document.getElementById("file_value").value = null;
        }
    };

    const handleSubmit = () => {
        if (!fileName || fileName.trim() === "") {
            toast.error("Upload the CSI File", {
                autoClose: 5000,
                progress: 0,
            });
            return;
        }

        if (!personFormData.responsible_pan || personFormData.responsible_pan.trim() === "") {
            toast.error("Responsible Person PAN is required", {
                autoClose: 3000,
                progress: 0,
            });
            return;
        }

        if (!personFormData.responsible_designation || personFormData.responsible_designation.trim() === "") {
            toast.error("Responsible Person Designation is required", {
                autoClose: 3000,
                progress: 0,
            });
            return;
        }

        const payload = {
            ...employerDetailFormData,
            ...taxDeductionFormData,
            ...personFormData,
            business_entity_id: localStorage.getItem('business_entity_id'),
            csi_file_data: CSIfile,
            csi_file_name: fileName,
            // same_as_prev_data: isEdit === 0
            //     ? null
            //     : (personFormData.responsible_address_same === true ? "Yes" : "No"),
            same_as_prev_data: personFormData.responsible_address_same === true ? "Yes" : "No",
            //  same_as_prev_data: (draftScreens.draft_screen_1 === null && draftScreens.draft_screen_2 === null)
            // ? null
            // : previousData || null,
            draft_screen_1: "yes",
            draft_screen_2: "yes",
            draft_screen_3: "yes"
        };

        console.log('Payload responsible_pan:', payload.responsible_pan);
        console.log('Payload responsible_designation:', payload.responsible_designation);

        const form24qId = localStorage.getItem('form24q_id');
        if (form24qId) {
            payload.id = parseInt(form24qId);
        }

        let url = "";
        let msg = "";
        if (isEdit === 0) {
            url = "/create_form_24q";
            msg = "Data saved successfully!";
        } else {
            url = "/update_form_24q";
            msg = "Data updated successfully!";
        }

        axios.post(url, payload)
            .then((res) => {
                if (res?.data.status === false) {
                    toast.error(res?.data?.message || msg, {
                        autoClose: 3000,
                        progress: 0,
                    });
                } else {
                    toast.success(res?.data?.message || msg, {
                        autoClose: 3000,
                        progress: 0,
                    });
                    getCombinedChallanDetails();
                    getForm24QData();
                    setActiveFormStep((prevActiveFormStep) => prevActiveFormStep + 1);
                    setFileName("");
                }
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message || "An error occurred while saving data.", {
                    autoClose: 3000,
                    progress: 0,
                });
            });
    };


    const handleFile24Q = () => {
        history.push('/24QFiling');
        const payLoadData = {
            business_entity_id: localStorage.getItem('business_entity_id'),
            financial_year: localStorage.getItem('financial_year_24Q'),
            quarter: localStorage.getItem('quarter_24Q'),
            tan: employerDetailFormData.tan
        };
        axios.post('/tds_24Q_filing', payLoadData)
            .then((res) => {
                // Handle response
            })
            .catch((err) => {
                console.error(err);
            });
    };

    const handleGenerateFUVFile = () => {
        setIsFUVGenerating(true);
        const payLoadData = {
            business_entity_id: localStorage.getItem('business_entity_id'),
            financial_year: localStorage.getItem('financial_year_24Q'),
            quarter: localStorage.getItem('quarter_24Q'),
            tan: employerDetailFormData.tan
        };

        axios.post('/tds_24Q_rpu_file_generation', payLoadData)
            .then((res) => {
                console.log('API Response:', res.data);
                // NEW: Check for validation failure and download error file
                if (res.data && res.data.success === false && res.data.status === "validation_failed") {
                    if (res.data.error_file_binary) {
                        const errorFileName = `Error_Report_${localStorage.getItem('quarter_24Q')}_${localStorage.getItem('financial_year_24Q')}.xlsx`;
                        downloadBase64File('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', res.data.error_file_binary, errorFileName);
                    }
                    if (res.data.error_report_file) {
                        const errorReportFileName = res.data.error_report_filename || `Validation_Error_Report_${localStorage.getItem('quarter_24Q')}_${localStorage.getItem('financial_year_24Q')}${res.data.error_report_extension || '.xlsx'}`;
                        const contentType = res.data.error_report_extension === '.xlsx'
                            ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                            : 'application/octet-stream';
                        downloadBase64File(contentType, res.data.error_report_file, errorReportFileName);
                    }
                    toast.error(res.data.message || 'Validation failed. Please check the error report.', {
                        autoClose: 5000,
                        progress: 0,
                    });
                    return;
                }

                // EXISTING: Check for success in response
                if (res.data && res.data.success === true) {

                    // Download FVU zip file (fvu_zip_file_binary field)
                    if (res.data.fvu_zip_file_binary) {
                        const fvuFileName = `FVU_${localStorage.getItem('quarter_24Q')}_${localStorage.getItem('financial_year_24Q')}.zip`;
                        downloadBase64File('application/zip', res.data.fvu_zip_file_binary, fvuFileName);
                    }

                    // Download TXT file (txt_file_binary field)
                    if (res.data.txt_file_binary) {
                        const txtFileName = `TXT_${localStorage.getItem('quarter_24Q')}_${localStorage.getItem('financial_year_24Q')}.txt`;
                        downloadBase64File('text/plain', res.data.txt_file_binary, txtFileName);
                    }

                    toast.success(res.data.message || 'FUV and TXT files downloaded successfully', {
                        autoClose: 3000,
                        progress: 0,
                    });
                } else {
                    toast.error(res.data.message || 'Failed to generate FUV file', {
                        autoClose: 3000,
                        progress: 0,
                    });
                }
            })
            .catch((err) => {
                console.error('Error:', err);
                toast.error(err?.response?.data?.message || 'An error occurred while generating FUV file', {
                    autoClose: 5000,
                    progress: 0,
                });
            })
            .finally(() => {
                setIsFUVGenerating(false);
            });
    };

    const downloadBase64File = (contentType, base64Data, fileName) => {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };

    const handleDownloadReport = () => {
        const financial_year = localStorage.getItem('financial_year_24Q');
        const contentType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const filename = `24Q Annexure RPU.xlsx`;

        axios
            .post(`/generate_tds_rpu_excel_report_for_24q`, {
                business_entity_id: localStorage.getItem("business_entity_id"),
                financial_year: financial_year,
                quarter: localStorage.getItem('quarter_24Q')
            })
            .then((res) => {
                downloadBase64File(contentType, res.data.file, filename);
            })
            .catch((error) => {
                console.log(error);
            }).finally(() => {
                // Add any cleanup if needed
            });
    };

    const handleOpenAutoDownload = () => {
        setAutoDownloadPhone(taxDeductionFormData.telephone_no || '');
        setOtpSent(false);
        setOtpValue('');
        setOtpReferenceId('');
        setAutoDownloadBusinessEntityId(localStorage.getItem('business_entity_id') || '');
        setAutoDownloadOpen(true);
    };

    const handleCloseAutoDownload = () => {
        setAutoDownloadOpen(false);
        setOtpSent(false);
        setOtpValue('');
        setOtpReferenceId('');
    };

    const handleSendOtp = () => {
        if (!autoDownloadPhone || autoDownloadPhone.trim() === '') {
            toast.error('Please enter a valid phone number', { autoClose: 3000, progress: 0 });
            return;
        }
        setIsSendingOtp(true);
        const payload = {
            tan: employerDetailFormData.tan,
            business_entity_id: localStorage.getItem('business_entity_id'),
            mobile_number: autoDownloadPhone,
            financial_year: employerDetailFormData.financial_year,
            quarter: employerDetailFormData.quarter,
        };
        axios.post('/generate_csi_otp', payload)
            .then((res) => {
                if (res?.data?.status === false) {
                    toast.error(res?.data?.message || 'Failed to send OTP', { autoClose: 3000, progress: 0 });
                } else {
                    toast.success(res?.data?.message || 'OTP sent successfully', { autoClose: 3000, progress: 0 });
                    setOtpReferenceId(res?.data?.reference_id || '');
                    setOtpSent(true);
                }
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message || 'An error occurred while sending OTP.', { autoClose: 3000, progress: 0 });
            })
            .finally(() => setIsSendingOtp(false));
    };

    const handleSubmitOtp = () => {
        if (!otpValue || otpValue.trim() === '') {
            toast.error('Please enter the OTP', { autoClose: 3000, progress: 0 });
            return;
        }
        if (!otpReferenceId) {
            toast.error('Missing reference ID. Please resend OTP.', { autoClose: 3000, progress: 0 });
            return;
        }
        setIsSubmittingOtp(true);
        const payload = {
            business_entity_id: localStorage.getItem('business_entity_id'),
            reference_id: otpReferenceId,
            otp: otpValue,
        };
        axios.post('/verify_csi_otp', payload)
            .then((res) => {
                if (res?.data?.status === false) {
                    toast.error(res?.data?.message || 'OTP verification failed', { autoClose: 3000, progress: 0 });
                } else {
                    toast.success(res?.data?.message || 'OTP verified successfully', { autoClose: 3000, progress: 0 });
                    handleCloseAutoDownload();
                }
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message || 'An error occurred while verifying OTP.', { autoClose: 3000, progress: 0 });
            })
            .finally(() => setIsSubmittingOtp(false));
    };

    const handleDownloadCSIFile = () => {
        setIsDownloadingCSI(true);
        const payload = {
            tan: employerDetailFormData.tan,
            business_entity_id: localStorage.getItem('business_entity_id'),
            financial_year: localStorage.getItem('financial_year_24Q'),
            quarter: localStorage.getItem('quarter_24Q'),
        };

        axios.post('/download_csi_file', payload)
            .then((res) => {
                if (res?.data?.status === false) {
                    toast.error(res?.data?.message || 'Failed to download CSI file', { autoClose: 3000, progress: 0 });
                    return;
                }
                const csiFileName = res?.data?.filename
                    || `CSI_${localStorage.getItem('quarter_24Q')}_${localStorage.getItem('financial_year_24Q')}.csi`;
                downloadBase64File('application/octet-stream', res.data.file_binary, csiFileName);
                toast.success(res?.data?.message || 'CSI file downloaded successfully', { autoClose: 3000, progress: 0 });
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message || 'An error occurred while downloading the CSI file.', {
                    autoClose: 3000, progress: 0,
                });
            })
            .finally(() => {
                setIsDownloadingCSI(false);
            });
    };

    const handleStepClick = (stepIndex) => {
        if (completedSteps.has(stepIndex) || stepIndex <= activeStep) {
            setActiveStep(stepIndex);
        }
        return;
    };

    const handleNext = () => {
        setActiveFormStep((prevActiveFormStep) => prevActiveFormStep + 1);
    };

    const handleBack = () => {
        getForm24QData();
        setActiveFormStep((prevActiveFormStep) => prevActiveFormStep - 1);
    };

    const typeOfDeductorOptions = [
        { value: 'Artificial Juridical Person (AOP)', label: 'Artificial Juridical Person (AOP)' },
        { value: 'Association of Person (Trust)', label: 'Association of Person (Trust)' },
        { value: 'Autonomous Body (Central Govt.)', label: 'Autonomous Body (Central Govt.)' },
        { value: 'Autonomous Body (State Govt.)', label: 'Autonomous Body (State Govt.)' },
        { value: 'Body of Individuals', label: 'Body of Individuals' },
        { value: 'Branch / Division of Company', label: 'Branch / Division of Company' },
        { value: 'Central Government', label: 'Central Government' },
        { value: 'Company', label: 'Company' },
        { value: 'Firm', label: 'Firm' },
        { value: 'Individual/HUF', label: 'Individual/HUF' },
        { value: 'Local Authority (Central Govt.)', label: 'Local Authority (Central Govt.)' },
        { value: 'Local Authority (State Govt.)', label: 'Local Authority (State Govt.)' },
        { value: 'State Government', label: 'State Government' },
        { value: 'Statutory Body (Central Govt.)', label: 'Statutory Body (Central Govt.)' },
        { value: 'Statutory Body (State Govt.)', label: 'Statutory Body (State Govt.)' }
    ];

    const getFinancialYearOptions = () => {
        const today = new Date();
        const currentMonth = today.getMonth();
        let currentYear = today.getFullYear();

        if (currentMonth < 3) {
            currentYear = currentYear - 1;
        }

        const financialYearOptions = [];

        for (let i = 5; i > 0; i--) {
            const startYear = currentYear - i;
            const endYear = startYear + 1;
            const value = `${startYear}-${String(endYear).slice(2)}`;
            financialYearOptions.push({ value: value, label: value });
        }

        const currentFYStartYear = currentYear;
        const currentFYEndYear = currentYear + 1;
        const currentFYValue = `${currentFYStartYear}-${String(currentFYEndYear).slice(2)}`;
        financialYearOptions.push({ value: currentFYValue, label: currentFYValue });

        for (let i = 1; i <= 5; i++) {
            const startYear = currentYear + i;
            const endYear = startYear + 1;
            const value = `${startYear}-${String(endYear).slice(2)}`;
            financialYearOptions.push({ value: value, label: value });
        }

        return financialYearOptions;
    };

    const financialYearOptions = getFinancialYearOptions();

    // Form Step Components
    const FormStep0 = () => {
        return (
            <ValidatorForm
                useRef="formStep0"
                onSubmit={handleFormDetailSubmit}
                onError={(errors) => console.log(errors)}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4} mt={0.7}>
                        <label style={{ display: 'block', marginBottom: '3px' }}>
                            Financial Year<span style={{ color: 'red' }}>*</span>:
                        </label>
                        <SelectInput
                            choice_id="value"
                            validator={['required']}
                            errorMsg={['Financial Year is required']}
                            choice_name="label"
                            name="financial_year"
                            value={employerDetailFormData.financial_year}
                            textOnchangeFunction={handleChange}
                            choices={financialYearOptions}
                            disabled={isViewOnly}
                            sx={{
                                height: '40px',
                                '& .MuiSelect-select': {
                                    padding: '10px 14px',
                                    fontSize: '1rem',
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Tax Deduction Account Number<span style={{ color: "red" }}>*</span>:
                        </label>
                        <TextValidator
                            fullWidth={true}
                            size="small"
                            variant="outlined"
                            name="tan"
                            placeholder="AAAA12345A"
                            value={employerDetailFormData.tan}
                            onChange={handleChange}
                            inputProps={{ maxLength: 10, readOnly: isViewOnly }}
                            validators={["required", "matchRegexp:^[A-Z]{4}[0-9]{5}[A-Z]{1}$"]}
                            errorMessages={["TAN is required", "Must be a Valid TAN number"]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>Last Tax Deduction Account Number:</label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="last_tan"
                            value={employerDetailFormData.last_tan}
                            onChange={handleChange}
                            inputProps={{ maxLength: 100, readOnly: isViewOnly }}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4}>
                        <label>Assessment Year<span style={{ color: "red" }}>*</span>:</label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="assessment_year"
                            value={employerDetailFormData.assessment_year}
                            onChange={handleChange}
                            inputProps={{ maxLength: 100, readOnly: isViewOnly }}
                            validators={["required"]}
                            errorMessages={["Assessment Year is required"]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>Permanent Account Number (PAN)<span style={{ color: "red" }}>*</span>:</label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="pan"
                            placeholder="ABCDE1234F"
                            value={employerDetailFormData.pan?.toUpperCase() ?? ""}
                            onChange={handleChange}
                            inputProps={{ maxLength: 10, readOnly: isViewOnly }}
                            validators={["required", "matchRegexp:^[A-Z]{3}[PCFTGHLABJ]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}$"]}
                            errorMessages={["PAN is required", "Must be a PAN number"]}
                        />
                        {errors["pan"] && (
                            <p style={{ color: '#ef4444', fontSize: '12px', marginTop: '4px', marginBottom: '0' }}>
                                {errors["pan"]}
                            </p>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={4} mt={0.7}>
                        <label style={{ display: 'block', marginBottom: '3px' }}>
                            Type of Deductor<span style={{ color: 'red' }}>*</span>:
                        </label>
                        <SelectInput
                            choice_id="value"
                            choice_name="label"
                            name="type_of_deductor"
                            value={employerDetailFormData.type_of_deductor}
                            textOnchangeFunction={handleChange}
                            choices={typeOfDeductorOptions}
                            disabled={isViewOnly}
                            sx={{
                                height: '40px',
                                '& .MuiSelect-select': {
                                    padding: '10px 14px',
                                    fontSize: '1rem',
                                },
                            }}
                        />
                        {errors["type_of_deductor"] && (
                            <p style={{ color: '#ef4444', fontSize: '12px', marginTop: '4px', marginBottom: '0' }}>
                                {"Type of Deductor is required"}
                            </p>
                        )}
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4} mt={0.7}>
                        <label style={{ display: 'block', marginBottom: '3px' }}>
                            Is this a Revised Return?:
                        </label>
                        <SelectInput
                            choice_id="id"
                            choice_name="reverse_charge"
                            name="is_revised_return"
                            value={employerDetailFormData.is_revised_return === true ? 1 : 2}
                            disabled={isViewOnly}
                            textOnchangeFunction={handleChange}
                            choices={[
                                { "id": 1, "reverse_charge": "Yes" },
                                { "id": 2, "reverse_charge": "No" }
                            ]}
                            sx={{
                                height: '40px',
                                '& .MuiSelect-select': {
                                    padding: '10px 14px',
                                    fontSize: '1rem',
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>Last Deductor type:</label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="last_deductor_type"
                            value={employerDetailFormData.last_deductor_type}
                            onChange={handleChange}
                            inputProps={{ maxLength: 100, readOnly: isViewOnly }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>Update Deductor Details:</label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="update_deductor_details"
                            value={employerDetailFormData.update_deductor_details}
                            onChange={handleChange}
                            inputProps={{ maxLength: 100, readOnly: isViewOnly }}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4}>
                        <label>Receipt Number of Original Return:</label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="receipt_number_original"
                            value={employerDetailFormData.receipt_number_original}
                            onChange={handleChange}
                            inputProps={{ maxLength: 100, readOnly: isViewOnly }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>Receipt Number of Previous Return:</label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="receipt_number_previous"
                            value={employerDetailFormData.receipt_number_previous}
                            onChange={handleChange}
                            inputProps={{ maxLength: 100, readOnly: isViewOnly }}
                        />
                    </Grid>
                </Grid>

                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    marginTop: '1.5%',
                }}>
                    <button
                        onClick={handleFormDetailsBack}
                        style={{
                            padding: '12px 24px',
                            backgroundColor: '#ffffff',
                            color: '#374151',
                            border: '1px solid #d1d5db',
                            borderRadius: '12px',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease-in-out'
                        }}
                    >
                        Back
                    </button>
                    <button
                        type="submit"
                        style={{
                            padding: '12px 24px',
                            backgroundColor: '#2563eb',
                            color: '#ffffff',
                            border: 'none',
                            borderRadius: '8px',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease-in-out',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#1d4ed8'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#2563eb'}
                    >
                        Continue
                    </button>
                </div>
            </ValidatorForm>
        );
    };

    const FormStep1 = () => {
        return (
            <ValidatorForm
                useRef="formStep1"
                onError={(errors) => console.log(errors)}
                onSubmit={handleFormDetailSubmit}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Employer Name
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="name"
                            value={taxDeductionFormData.name}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 75, readOnly: isViewOnly }}
                            validators={["required"]}
                            errorMessages={["This field is required"]}
                        />
                        {errors["name"] && (
                            <p style={{
                                color: '#ef4444',
                                fontSize: '12px',
                                marginTop: '4px',
                                marginBottom: '0'
                            }}>
                                {"Employer Name is required"}
                            </p>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>Ministry / Dept. Name:</label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="ministry_department_name"
                            value={taxDeductionFormData.ministry_department_name}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100, readOnly: isViewOnly }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>Branch / Division:</label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="branch_division"
                            value={taxDeductionFormData.branch_division}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 75, readOnly: isViewOnly }}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4}>
                        <label>Ministry / Dept. Name (Others):</label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="ministry_department_name_other"
                            value={taxDeductionFormData.ministry_department_name_other}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100, readOnly: isViewOnly }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} mt={0.7}>
                        <label style={{ display: 'block', marginBottom: '3px' }}>State Name:</label>
                        <SelectInput
                            choice_id="id"
                            choice_name="value"
                            name="state_name"
                            value={taxDeductionFormData.state_name}
                            textOnchangeFunction={handleEmployerChange}
                            choices={State}
                            disabled={isViewOnly}
                            sx={{
                                height: '40px',
                                '& .MuiSelect-select': {
                                    padding: '10px 14px',
                                    fontSize: '1rem',
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>DDO Code:</label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="ddo_code"
                            value={taxDeductionFormData.ddo_code}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100, readOnly: isViewOnly }}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4}>
                        <label>PAO Code:</label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="pao_code"
                            value={taxDeductionFormData.pao_code}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100, readOnly: isViewOnly }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>DDO Registration Number:</label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="ddo_registration_number"
                            value={taxDeductionFormData.ddo_registration_number}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100, readOnly: isViewOnly }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>PAO Registration Number:</label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="pao_registration_number"
                            value={taxDeductionFormData.pao_registration_number}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100, readOnly: isViewOnly }}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4}>
                        <label>Flat No.<span style={{ color: "red" }}>*</span>:</label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="flat_no"
                            value={taxDeductionFormData.flat_no}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100, readOnly: isViewOnly }}
                            validators={["required"]}
                            errorMessages={["Flat No is required"]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>Name of Premises / Building:</label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="premises_name"
                            value={taxDeductionFormData.premises_name}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100, readOnly: isViewOnly }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>Road / Street / Lane:<span style={{ color: "red" }}>*</span>:</label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="road_or_street"
                            value={taxDeductionFormData.road_or_street}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 25, readOnly: isViewOnly }}
                            validators={["required"]}
                            errorMessages={["This field is required"]}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4}>
                        <label>Area / Location:<span style={{ color: "red" }}>*</span>:</label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="area_or_location"
                            value={taxDeductionFormData.area_or_location}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 25, readOnly: isViewOnly }}
                            validators={["required"]}
                            errorMessages={["This field is required"]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>Town / City / District:<span style={{ color: "red" }}>*</span>:</label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="town_or_city"
                            value={taxDeductionFormData.town_or_city}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 25, readOnly: isViewOnly }}
                            validators={["required"]}
                            errorMessages={["This field is required"]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>PIN Code<span style={{ color: "red" }}>*</span>:</label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="pin_code"
                            value={taxDeductionFormData.pin_code}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 6, readOnly: isViewOnly }}
                            onKeyPress={(event) => {
                                if (!/^[0-9]$/.test(event.key)) {
                                    event.preventDefault();
                                }
                            }}
                            validators={["required", 'matchRegexp:^[0-9]{6}$']}
                            errorMessages={["Pin Code is required", 'Must be a 6-digit pincode']}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4} mt={0.7}>
                        <label style={{ display: 'block', marginBottom: '3px' }}>
                            State<span style={{ color: "red" }}>*</span>:
                        </label>
                        <SelectInput
                            choice_id="value"
                            choice_name="value"
                            name="state"
                            value={taxDeductionFormData.state}
                            textOnchangeFunction={handleEmployerChange}
                            choices={State}
                            validators={["required"]}
                            errorMessages={["State is required"]}
                            disabled={isViewOnly}
                            sx={{
                                height: '40px',
                                '& .MuiSelect-select': {
                                    padding: '10px 14px',
                                    fontSize: '1rem',
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>Telephone No:<span style={{ color: "red" }}>*</span>:</label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="telephone_no"
                            value={taxDeductionFormData.telephone_no}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 10, readOnly: isViewOnly }}
                            validators={["required", "matchRegexp:^[1-9]{1}[0-9]{9}$"]}
                            errorMessages={["This field is required", "Invalid mobile number"]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>Telephone No (Alternative):</label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="telephone_alternative"
                            value={taxDeductionFormData.telephone_alternative}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 10, readOnly: isViewOnly }}
                            validators={["matchRegexp:^[0-9]{10}$"]}
                            errorMessages={["Invalid mobile number"]}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4}>
                        <label>E-mail:<span style={{ color: "red" }}>*</span>:</label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="email"
                            value={taxDeductionFormData.email}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 75, readOnly: isViewOnly }}
                            validators={["required", "isEmail"]}
                            errorMessages={["This field is required", "Email is not Valid"]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>E-mail (Alternative):</label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="email_alternative"
                            value={taxDeductionFormData.email_alternative}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100, readOnly: isViewOnly }}
                            validators={["isEmail"]}
                            errorMessages={["Email is not Valid"]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>Account Office Identification Number (AIN):</label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="ao_ain"
                            value={taxDeductionFormData.ao_ain}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100, readOnly: isViewOnly }}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4} mt={0.7}>
                        <label style={{ display: 'block', marginBottom: '3px' }}>
                            Has Address Changed since Last Return?:
                        </label>
                        <SelectInput
                            choice_id="id"
                            choice_name="reverse_charge"
                            name="has_address_changed"
                            value={taxDeductionFormData.has_address_changed === true ? 1 : 2}
                            textOnchangeFunction={handleEmployerChange}
                            choices={[
                                { "id": 1, "reverse_charge": "Yes" },
                                { "id": 2, "reverse_charge": "No" }
                            ]}
                            disabled={isViewOnly}
                            sx={{
                                height: '40px',
                                '& .MuiSelect-select': {
                                    padding: '10px 14px',
                                    fontSize: '1rem',
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>Goods and Service Tax Number (GSTN):<span style={{ color: "red" }}>*</span>:</label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="gstn"
                            placeholder="22ABCDE1234F1Z5"
                            value={taxDeductionFormData.gstn}
                            validators={["required", "matchRegexp:^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[1-9A-Za-z]{1}[CZ]{1}[0-9A-Za-z]{1}$"]}
                            errorMessages={["GSTIN is required", "Must be a Valid GSTN number"]}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 15, readOnly: isViewOnly }}
                        />
                    </Grid>
                </Grid>

                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    marginTop: '1.5%',
                }}>
                    <button
                        onClick={handleFormDetailsBack}
                        style={{
                            padding: '12px 24px',
                            backgroundColor: '#ffffff',
                            color: '#374151',
                            border: '1px solid #d1d5db',
                            borderRadius: '12px',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease-in-out'
                        }}
                    >
                        Back
                    </button>
                    <button
                        type="submit"
                        style={{
                            padding: '12px 24px',
                            backgroundColor: '#2563eb',
                            color: '#ffffff',
                            border: 'none',
                            borderRadius: '8px',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease-in-out',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#1d4ed8'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#2563eb'}
                    >
                        Continue
                    </button>
                </div>
            </ValidatorForm>
        );
    };

    const FormStep2 = () => {
        return (
            <>
                <ValidatorForm
                    useRef="formStep2"
                    onError={(errors) => console.log(errors)}
                    onSubmit={handleSubmit}
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4} mt={0.7}>
                            <label>Same as previous data:</label>
                            <SelectInput
                                choice_id="id"
                                choice_name="reverse_charge"
                                name="responsible_address_same"
                                value={personFormData.responsible_address_same === true ? 1 : 2}
                                textOnchangeFunction={handleDeductorChange}
                                choices={[
                                    { "id": 1, "reverse_charge": "Yes" },
                                    { "id": 2, "reverse_charge": "No" }
                                ]}
                                disabled={isViewOnly}
                                sx={{
                                    height: '40px',
                                    '& .MuiSelect-select': {
                                        padding: '10px 14px',
                                        fontSize: '1rem',
                                    },
                                }}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={12} sm={4}>
                            <label>Name<span style={{ color: "red" }}>*</span>:</label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_name"
                                value={personFormData.responsible_name}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 75, readOnly: isViewOnly }}
                                validators={["required"]}
                                errorMessages={["Name is required"]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>Permanent Account Number (PAN)<span style={{ color: "red" }}>*</span>:</label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_pan"
                                placeholder="ABCDE1234F"
                                value={personFormData.responsible_pan?.toUpperCase() ?? ""}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 10, readOnly: isViewOnly }}
                                // validators={
                                //     personFormData.responsible_address_same === true
                                //         ? ["required", "matchRegexp:^[A-Z]{3}[PCFTGHLABJ]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}$"]
                                //         : ["required", "matchRegexp:^[A-Z]{3}[PCFTGHLABJ]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}$", "isPANDifferent"]
                                // }
                                // errorMessages={
                                //     personFormData.responsible_address_same === true
                                //         ? ["PAN is required", "Must be a  Valid PAN number"]
                                //         : ["PAN is required", "Must be a Valid PAN number", "Responsible person PAN cannot be same as Deductor PAN"]
                                // }
                                validators={[
                                    "required",
                                    "matchRegexp:^[A-Z]{3}[PCFTGHLABJ]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}$",
                                    "isPANDifferent"
                                ]}
                                errorMessages={[
                                    "PAN is required",
                                    "Must be a Valid PAN number",
                                    "Responsible person PAN cannot be same as Deductor PAN"
                                ]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>Designation<span style={{ color: "red" }}>*</span>:</label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_designation"
                                value={personFormData.responsible_designation}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 20, readOnly: isViewOnly }}
                                validators={["required"]}
                                errorMessages={["Designation is required"]}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={12} sm={4}>
                            <label>Flat No.<span style={{ color: "red" }}>*</span>:</label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_flat_no"
                                value={personFormData.responsible_flat_no}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 100, readOnly: isViewOnly }}
                                validators={["required"]}
                                errorMessages={["Flat No is required"]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>Name of Premises / Building:</label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_premises_name"
                                value={personFormData.responsible_premises_name}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 25, readOnly: isViewOnly }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>Road / Street / Lane<span style={{ color: "red" }}>*</span>:</label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_road_or_street"
                                value={personFormData.responsible_road_or_street}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 25, readOnly: isViewOnly }}
                                validators={["required"]}
                                errorMessages={["This field is required"]}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={12} sm={4}>
                            <label>Area / Location<span style={{ color: "red" }}>*</span>:</label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_area_or_location"
                                value={personFormData.responsible_area_or_location}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 25, readOnly: isViewOnly }}
                                validators={["required"]}
                                errorMessages={["This field is required"]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>Town / City / District<span style={{ color: "red" }}>*</span>:</label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_town_or_city"
                                value={personFormData.responsible_town_or_city}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 25, readOnly: isViewOnly }}
                                validators={["required"]}
                                errorMessages={["This field is required"]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>PIN Code<span style={{ color: "red" }}>*</span>:</label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_pin_code"
                                value={personFormData.responsible_pin_code}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 6, readOnly: isViewOnly }}
                                onKeyPress={(event) => {
                                    if (!/^[0-9]$/.test(event.key)) {
                                        event.preventDefault();
                                    }
                                }}
                                validators={["required", "matchRegexp:^[0-9]{6}$"]}
                                errorMessages={["Pin Code is required", "Must be a 6-digit pincode"]}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={12} sm={4} mt={0.7}>
                            <label style={{ display: 'block', marginBottom: '3px' }}>
                                State<span style={{ color: "red" }}>*</span>:
                            </label>
                            <SelectInput
                                choice_id="value"
                                choice_name="value"
                                name="responsible_state"
                                value={personFormData.responsible_state}
                                textOnchangeFunction={handleDeductorChange}
                                choices={State}
                                validators={["required"]}
                                disabled={isViewOnly}
                                errorMessages={["State is required"]}
                                sx={{
                                    height: '40px',
                                    '& .MuiSelect-select': {
                                        padding: '10px 14px',
                                        fontSize: '1rem',
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>Telephone No<span style={{ color: "red" }}>*</span>:</label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_telephone_no"
                                value={personFormData.responsible_telephone_no}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 100, readOnly: isViewOnly }}
                                validators={["required", "matchRegexp:^[0-9]{10}$"]}
                                errorMessages={["This field is required", "Invalid mobile number"]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>Telephone No (Alternative):</label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_telephone_alternative"
                                value={personFormData.responsible_telephone_alternative}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 100, readOnly: isViewOnly }}
                                validators={["matchRegexp:^[0-9]{10}$"]}
                                errorMessages={["Invalid mobile number"]}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={12} sm={4}>
                            <label>E-mail<span style={{ color: "red" }}>*</span>:</label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_email"
                                value={personFormData.responsible_email}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 75, readOnly: isViewOnly }}
                                validators={["required", "isEmail"]}
                                errorMessages={["This field is required", "Email is not Valid"]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>E-mail (Alternative):</label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_email_alternative"
                                value={personFormData.responsible_email_alternative}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 75, readOnly: isViewOnly }}
                                validators={["isEmail"]}
                                errorMessages={["Email is not Valid"]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>Mobile No.</label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_mobile_no"
                                value={personFormData.responsible_mobile_no}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 10, readOnly: isViewOnly }}
                                validators={["matchRegexp:^[1-9]{1}[0-9]{9}$"]}
                                errorMessages={["Invalid mobile number"]}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={12} sm={4} mt={1}>
                            <label style={{ display: 'block', marginBottom: '3px' }}>
                                Has Address Changed since Last Return?:
                            </label>
                            <SelectInput
                                choice_id="id"
                                choice_name="reverse_charge"
                                name="responsible_address_changed"
                                value={personFormData.responsible_address_changed === true ? 1 : 2}
                                textOnchangeFunction={handleDeductorChange}
                                choices={[
                                    { "id": 1, "reverse_charge": "Yes" },
                                    { "id": 2, "reverse_charge": "No" }
                                ]}
                                disabled={isViewOnly}
                                sx={{
                                    height: '40px',
                                    '& .MuiSelect-select': {
                                        padding: '10px 14px',
                                        fontSize: '1rem',
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>Receipt No. of earlier Statement filed for Form:</label>
                            <SelectInput
                                choice_id="id"
                                choice_name="reverse_charge"
                                name="responsible_receipt_number"
                                value={personFormData.responsible_receipt_number === true ? 1 : 2}
                                textOnchangeFunction={handleDeductorChange}
                                choices={[
                                    { "id": 1, "reverse_charge": "Yes" },
                                    { "id": 2, "reverse_charge": "No" }
                                ]}
                                disabled={isViewOnly}
                                sx={{
                                    height: '40px',
                                    '& .MuiSelect-select': {
                                        padding: '10px 14px',
                                        fontSize: '1rem',
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>Has regular statement for Form 24Q filed for earlier period:</label>
                            <SelectInput
                                choice_id="id"
                                choice_name="reverse_charge"
                                name="filed_earlier_period"
                                value={personFormData.filed_earlier_period === true ? 1 : 2}
                                textOnchangeFunction={handleDeductorChange}
                                choices={[
                                    { "id": 1, "reverse_charge": "Yes" },
                                    { "id": 2, "reverse_charge": "No" }
                                ]}
                                disabled={isViewOnly}
                                sx={{
                                    height: '40px',
                                    '& .MuiSelect-select': {
                                        padding: '10px 14px',
                                        fontSize: '1rem',
                                    },
                                }}
                            />
                        </Grid>
                        {personFormData.filed_earlier_period === true && (
                            <Grid item xs={12} sm={4}>
                                <label>Previous Statement Number<span style={{ color: "red" }}>*</span>:</label>
                                <TextValidator
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    name="previous_statement_number"
                                    value={personFormData.previous_statement_number || ''}
                                    onChange={handleDeductorChange}
                                    inputProps={{ maxLength: 15, readOnly: isViewOnly }}
                                    onKeyPress={(e) => {
                                        if (!/[0-9]/.test(e.key)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    validators={["required", "matchRegexp:^[0-9]{1,15}$"]}
                                    errorMessages={[
                                        "Previous Statement Number is required",
                                        "Only numbers allowed (max 15 digits)"
                                    ]}
                                />
                            </Grid>
                        )}
                    </Grid>

                    <BoxWrapper boxTitle="CSI File Upload">
                        <Grid container spacing={3} alignItems="center">
                            <Grid item xs={3} md={1}>
                                <label
                                    className="button-primary"
                                    disabled={isViewOnly}
                                    style={{
                                        width: "100%",
                                        textAlign: "center",
                                        cursor: "pointer",
                                    }}
                                >
                                    Browse
                                    <input
                                        id="file_value"
                                        name="CSIfile"
                                        accept=".csi"
                                        type="file"
                                        hidden
                                        onChange={fileUploader}
                                    />
                                </label>
                            </Grid>
                            <Grid item xs={4} md={4}>
                                <TextValidator
                                    validators={["required"]}
                                    errorMessages={["This field is required"]}
                                    placeholder="Choose file"
                                    value={fileName}
                                    disabled={isViewOnly}
                                    name="csi_file_uploader"
                                    inputProps={{
                                        readOnly: true,
                                    }}
                                    fullWidth
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={4} md={2}>
                                <button
                                    type="button"
                                    className="button-primary"
                                    onClick={handleOpenAutoDownload}
                                    style={{
                                        width: "auto",
                                        padding: "6px 14px",
                                        textAlign: "center",
                                        cursor: "pointer",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    Auto Download
                                </button>
                            </Grid>
                            <Grid item xs={4} md={2}>
                                <button
                                    type="button"
                                    onClick={handleDownloadCSIFile}
                                    disabled={isDownloadingCSI}
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "6px",
                                        width: "auto",
                                        padding: "6px 12px",
                                        fontSize: "13px",
                                        fontWeight: 600,
                                        color: isDownloadingCSI ? "#94a3b8" : "#0d3f66",
                                        backgroundColor: "#ffffff",
                                        border: `1px solid ${isDownloadingCSI ? "#e2e8f0" : "#0d3f66"}`,
                                        borderRadius: "6px",
                                        cursor: isDownloadingCSI ? "not-allowed" : "pointer",
                                        whiteSpace: "nowrap",
                                        transition: "all 0.2s ease-in-out",
                                    }}
                                    onMouseOver={(e) => {
                                        if (!isDownloadingCSI) {
                                            e.currentTarget.style.backgroundColor = "#0d3f66";
                                            e.currentTarget.style.color = "#ffffff";
                                        }
                                    }}
                                    onMouseOut={(e) => {
                                        if (!isDownloadingCSI) {
                                            e.currentTarget.style.backgroundColor = "#ffffff";
                                            e.currentTarget.style.color = "#0d3f66";
                                        }
                                    }}
                                >
                                    {isDownloadingCSI ? (
                                        <svg
                                            width="14" height="14" viewBox="0 0 16 16"
                                            style={{ animation: "spin 0.9s linear infinite", flexShrink: 0 }}
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <circle
                                                cx="8" cy="8" r="6"
                                                fill="none" stroke="currentColor"
                                                strokeWidth="2" strokeDasharray="28"
                                                strokeDashoffset="10" strokeLinecap="round"
                                            />
                                        </svg>
                                    ) : (
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                            <polyline points="7 10 12 15 17 10" />
                                            <line x1="12" y1="15" x2="12" y2="3" />
                                        </svg>
                                    )}
                                    {isDownloadingCSI ? "Downloading..." : "Download CSI"}
                                </button>
                            </Grid>
                        </Grid>
                    </BoxWrapper>

                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        marginTop: '1.5%',
                    }}>
                        <button
                            type="button"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleFormDetailsBack();
                            }}
                            style={{
                                padding: '12px 24px',
                                backgroundColor: '#ffffff',
                                color: '#374151',
                                border: '1px solid #d1d5db',
                                borderRadius: '12px',
                                fontSize: '14px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease-in-out'
                            }}
                        >
                            Back
                        </button>
                        <button type="submit"
                            style={{
                                padding: '12px 24px',
                                backgroundColor: '#1d4ed8',
                                color: '#ffffff',
                                border: 'none',
                                borderRadius: '8px',
                                fontSize: '14px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease-in-out',
                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                            }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#1d4ed8'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#2563eb'}
                        >
                            Submit
                        </button>
                    </div>
                </ValidatorForm>
            </>
        );
    };

    // Update formSteps array to include all three steps with proper content references
    const formSteps = [
        { id: 0, title: 'Particulars of Deductor (Employer)', description: 'Basic details of the deductor (Employer)', content: FormStep0 },
        { id: 1, title: 'Deduction of Tax', description: 'Particulars of the Person Responsible for Deduction of Tax', content: FormStep1 },
        { id: 2, title: 'Person Responsible', description: 'Details of person responsible for deduction of tax', content: FormStep2 }
    ];

    // Update renderFormStep to handle all three steps
    const renderFormStep = () => {
        switch (activeStep) {
            case 0:
                return FormStep0();
            case 1:
                return FormStep1();
            case 2:
                return FormStep2();
            default:
                return FormStep0();
        }
    };

    // Add AnnexureTable component
    const annexureColumns = [
        {
            field: 'challan_no',
            headerName: 'Challan No',
            flex: 1,
            minWidth: 120,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
        },
        {
            field: 'section',
            headerName: 'Section',
            flex: 0.8,
            minWidth: 90,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
        },
        {
            field: 'pan',
            headerName: 'PAN',
            flex: 1.2,
            minWidth: 130,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            align: 'left',
        },
        {
            field: 'name',
            headerName: 'Name',
            flex: 1.5,
            minWidth: 180,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            align: 'left',
        },
        {
            field: 'date_of_payment',
            headerName: 'Date of Payment',
            flex: 1.3,
            minWidth: 160,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
        },
        {
            field: 'date_of_deduction',
            headerName: 'Date of Deduction',
            flex: 1.3,
            minWidth: 170,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
        },
        {
            field: 'tds',
            headerName: 'TDS',
            flex: 1,
            minWidth: 110,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => formatCurrency(params.value),
        },
        {
            field: 'surcharge',
            headerName: 'Surcharge',
            flex: 1,
            minWidth: 120,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => formatCurrency(params.value),
        },
        {
            field: 'cess',
            headerName: 'CESS',
            flex: 1,
            minWidth: 100,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => formatCurrency(params.value),
        },
        {
            field: 'tax',
            headerName: 'Tax',
            flex: 1,
            minWidth: 100,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => formatCurrency(params.value),
        },
        {
            field: 'amount_paid',
            headerName: 'Amount Paid',
            flex: 1.2,
            minWidth: 140,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => formatCurrency(params.value),
        },
    ];

    const AnnexureTable = () => (
        <div style={{ marginTop: '20px', width: '100%', overflow: 'hidden' }}>
            <div style={{ width: '100%', height: '65vh' }}>
                <DataGridPro
                    rows={annexureData}
                    columns={annexureColumns}
                    getRowId={(row) => `${row.challan_no}-${row.pan}`}
                    pagination
                    pageSize={pageSize}
                    pageSizeOptions={[5, 10, 25, 50]}
                    checkboxSelection={false}
                    disableRowSelectionOnClick
                    isRowSelectable={() => false}
                    disableColumnFilter
                    disableColumnMenu
                    disableColumnSelector
                    autoHeight={false}
                    disableVirtualization={false}
                    hideFooterSelectedRowCount
                    sx={{
                        height: '100%',
                        width: '100%',
                        backgroundColor: '#ffffff',
                        border: '1px solid #e0e0e0',
                        borderRadius: '8px',
                        '& .MuiDataGrid-main': {
                            overflow: 'hidden',
                        },
                        '& .MuiDataGrid-virtualScroller': {
                            backgroundColor: '#ffffff',
                            overflowY: 'auto',
                            overflowX: 'auto',
                        },
                        '& .MuiDataGrid-columnHeaders': {
                            background: '#124485',
                            borderBottom: '1px solid #e0e0e0',
                            minHeight: '56px !important',
                            maxHeight: '56px !important',
                        },
                        '& .MuiDataGrid-columnHeader': {
                            background: 'transparent',
                            padding: '12px 16px',
                            borderRight: '1px solid rgba(255, 255, 255, 0.3)',
                            '&:focus': {
                                outline: 'none',
                            },
                            '&:focus-within': {
                                outline: 'none',
                            }
                        },
                        '& .MuiDataGrid-columnHeaderTitle': {
                            color: '#ffffff',
                            fontWeight: '600',
                            fontSize: '0.875rem',
                        },
                        '& .MuiDataGrid-columnHeaderTitleContainer': {
                            padding: 0,
                            justifyContent: 'center',
                        },
                        '& .MuiDataGrid-columnSeparator': {
                            display: 'none',
                        },
                        '& .MuiDataGrid-sortIcon': {
                            display: 'none !important',
                        },
                        '& .MuiDataGrid-iconButtonContainer': {
                            display: 'none !important',
                        },
                        '& .MuiDataGrid-menuIconButton': {
                            display: 'none !important',
                        },
                        '& .MuiDataGrid-row:nth-of-type(odd)': {
                            backgroundColor: '#E8F2FF',
                        },
                        '& .MuiDataGrid-row:nth-of-type(even)': {
                            backgroundColor: '#F5F9FF',
                        },
                        '& .MuiDataGrid-row': {
                            borderBottom: '1px solid #f0f0f0',
                            '&:hover': {
                                backgroundColor: '#f9f9f9',
                                cursor: 'pointer',
                            },
                        },
                        '& .MuiDataGrid-cell': {
                            padding: '12px 16px',
                            fontSize: '0.875rem',
                            color: '#333',
                            borderRight: '1px solid #f0f0f0',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        },
                        '& .MuiDataGrid-cell[data-field="pan"]': {
                            paddingLeft: '8px',
                            justifyContent: 'flex-start',
                        },
                        '& .MuiDataGrid-cell[data-field="name"]': {
                            justifyContent: 'flex-start',
                            paddingLeft: '8px',
                        },
                        '& .MuiDataGrid-footerContainer': {
                            backgroundColor: '#fafafa',
                            borderTop: '2px solid #e0e0e0',
                            minHeight: '52px',
                        },
                        '& .MuiTablePagination-root': {
                            color: '#666',
                        },
                    }}
                />
            </div>
        </div>
    );

    const FormDetails = () => {
        return (
            <div style={{ backgroundColor: 'rgb(246, 246, 249)', padding: '8px' }}>
                <div style={{
                    maxWidth: 'auto',
                    margin: '0 auto',
                    backgroundColor: '#ffffff',
                    borderRadius: '16px',
                    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
                    overflow: 'hidden'
                }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '360px 1fr' }}>
                        <div style={{ backgroundColor: '#f8fafc', padding: '24px', borderRight: '1px solid #e5e7eb' }}>
                            <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#374151', marginBottom: '20px' }}>
                                24Q Filing (Form-138) Details
                            </h3>
                            {formSteps.map((step) => (
                                <StepIndicator
                                    key={step.id}
                                    step={step}
                                    isActive={activeStep === step.id}
                                    isCompleted={completedSteps.has(step.id)}
                                    onClick={handleStepClick}
                                />
                            ))}
                        </div>
                        <div style={{ padding: '2%' }}>
                            <div>{renderFormStep()}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const formatCurrency = (value) => {
        if (!value || value == null || value === '') return '₹0';
        return `₹${value.toLocaleString('en-IN')}`;
    };

    const StepIndicator = ({ step, isActive, isCompleted, onClick }) => (
        <div
            onClick={() => onClick(step.id)}
            style={{
                display: 'flex',
                alignItems: 'center',
                padding: '16px',
                borderRadius: '12px',
                backgroundColor: isActive ? '#eff6ff' : isCompleted ? '#f0f9ff' : '#f8fafc',
                border: isActive ? '2px solid #2563eb' : '1px solid #e5e7eb',
                cursor: (isCompleted || step.id <= activeStep) ? 'pointer' : 'not-allowed',
                transition: 'all 0.2s ease-in-out',
                opacity: (isCompleted || step.id <= activeStep) ? 1 : 0.6,
                marginBottom: '12px'
            }}
        >
            <div
                style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    backgroundColor: isCompleted ? '#10b981' : isActive ? '#2563eb' : '#e5e7eb',
                    color: isCompleted || isActive ? '#ffffff' : '#6b7280',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '14px',
                    fontWeight: '600',
                    marginRight: '12px',
                    flexShrink: 0
                }}
            >
                {isCompleted ? <CheckIcon size={16} /> : step.id + 1}
            </div>
            <div style={{ flex: 1 }}>
                <div style={{
                    fontSize: '16px',
                    fontWeight: '600',
                    color: isActive ? '#2563eb' : '#374151',
                    marginBottom: '4px'
                }}>
                    {step.title}
                </div>
                <div style={{
                    fontSize: '14px',
                    color: '#6b7280'
                }}>
                    {step.description}
                </div>
            </div>
            {isActive && <ChevronRightIcon size={20} color="#2563eb" />}
        </div>
    );

    const challanColumns = [
        {
            field: 'challan_no',
            headerName: 'Challan No',
            flex: 1,
            minWidth: 120,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
        },
        {
            field: 'challan_date',
            headerName: 'Challan Date',
            flex: 1,
            minWidth: 130,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
        },
        {
            field: 'bsr_code',
            headerName: 'BSR Code',
            flex: 1,
            minWidth: 110,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
        },
        {
            field: 'section',
            headerName: 'Section',
            flex: 1,
            minWidth: 100,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
        },
        {
            field: 'tds',
            headerName: 'TDS',
            flex: 1,
            minWidth: 110,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => formatCurrency(params.value),
        },
        {
            field: 'surcharge',
            headerName: 'Surcharge',
            flex: 1,
            minWidth: 120,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => formatCurrency(params.value),
        },
        {
            field: 'cess',
            headerName: 'CESS',
            flex: 1,
            minWidth: 100,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => formatCurrency(params.value),
        },
        {
            field: 'interest',
            headerName: 'Interest',
            flex: 1,
            minWidth: 110,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => formatCurrency(params.value),
        },
        {
            field: 'penalty',
            headerName: 'Penalty',
            flex: 1,
            minWidth: 110,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => formatCurrency(params.value),
        },
        {
            field: 'fee',
            headerName: 'Fees',
            flex: 1,
            minWidth: 100,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => formatCurrency(params.value),
        },
        {
            field: 'total',
            headerName: 'Total',
            flex: 1,
            minWidth: 120,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => formatCurrency(params.value),
        },
    ];

    const ChallanTable = () => (
        <div style={{ marginTop: '20px', width: '100%', overflow: 'hidden' }}>
            <div style={{ width: '100%', height: '65vh' }}>
                <DataGridPro
                    rows={challanData}
                    columns={challanColumns}
                    getRowId={(row) => row.sr_no}
                    pagination
                    pageSize={pageSize}
                    pageSizeOptions={[5, 10, 25, 50]}
                    checkboxSelection={false}
                    disableRowSelectionOnClick
                    isRowSelectable={() => false}
                    disableColumnFilter
                    disableColumnMenu
                    disableColumnSelector
                    autoHeight={false}
                    disableVirtualization={false}
                    hideFooterSelectedRowCount
                    sx={{
                        height: '100%',
                        width: '100%',
                        backgroundColor: '#ffffff',
                        border: '1px solid #e0e0e0',
                        borderRadius: '8px',
                        '& .MuiDataGrid-main': {
                            overflow: 'hidden',
                        },
                        '& .MuiDataGrid-virtualScroller': {
                            backgroundColor: '#ffffff',
                            overflowY: 'auto',
                            overflowX: 'auto',
                        },
                        '& .MuiDataGrid-columnHeaders': {
                            background: '#124485',
                            borderBottom: '1px solid #e0e0e0',
                            minHeight: '56px !important',
                            maxHeight: '56px !important',
                        },
                        '& .MuiDataGrid-columnHeader': {
                            background: 'transparent',
                            padding: '12px 16px',
                            borderRight: '1px solid rgba(255, 255, 255, 0.3)',
                            '&:focus': {
                                outline: 'none',
                            },
                            '&:focus-within': {
                                outline: 'none',
                            }
                        },
                        '& .MuiDataGrid-columnHeaderTitle': {
                            color: '#ffffff',
                            fontWeight: '600',
                            fontSize: '0.875rem',
                        },
                        '& .MuiDataGrid-columnHeaderTitleContainer': {
                            padding: 0,
                            justifyContent: 'center',
                        },
                        '& .MuiDataGrid-columnSeparator': {
                            display: 'none',
                        },
                        '& .MuiDataGrid-sortIcon': {
                            display: 'none !important',
                        },
                        '& .MuiDataGrid-iconButtonContainer': {
                            display: 'none !important',
                        },
                        '& .MuiDataGrid-menuIconButton': {
                            display: 'none !important',
                        },
                        '& .MuiDataGrid-row:nth-of-type(odd)': {
                            backgroundColor: '#E8F2FF',
                        },
                        '& .MuiDataGrid-row:nth-of-type(even)': {
                            backgroundColor: '#F5F9FF',
                        },
                        '& .MuiDataGrid-row': {
                            backgroundColor: '#ffffff',
                            borderBottom: '1px solid #f0f0f0',
                            '&:hover': {
                                backgroundColor: '#f9f9f9',
                                cursor: 'pointer',
                            },
                        },
                        '& .MuiDataGrid-cell': {
                            padding: '12px 16px',
                            fontSize: '0.875rem',
                            color: '#333',
                            borderRight: '1px solid #f0f0f0',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        },
                        '& .MuiDataGrid-footerContainer': {
                            backgroundColor: '#fafafa',
                            borderTop: '2px solid #e0e0e0',
                            minHeight: '52px',
                        },
                        '& .MuiTablePagination-root': {
                            color: '#666',
                        },
                    }}
                />
            </div>
        </div>
    );

    return (
        <>
            <Box position="relative" mb={1}>
                <Typography variant="h6" align="center" sx={{ fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase' }}>
                    24Q Filing (Form-138) ({localStorage.getItem('financial_year_24Q')} {localStorage.getItem('quarter_24Q')})
                </Typography>

                {activeFormStep !== 0 && (
                    <Button
                        variant="outlined"
                        endIcon={
                            <img
                                src={excelIconImage}
                                alt="Excel"
                                style={{ width: 20, height: 20 }}
                            />
                        }
                        color="success"
                        sx={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            textTransform: 'none',
                            fontWeight: 600,
                        }}
                        onClick={handleDownloadReport}
                    >
                        Export
                    </Button>
                )}
            </Box>

            <Box sx={{ mt: 2 }}>
                {activeFormStep === 0 && FormDetails()}
                {activeFormStep === 1 && <ChallanTable />}
                {activeFormStep === 2 && <AnnexureTable />}
            </Box>

            <Stack direction="row" spacing={2} sx={{ mt: 6, justifyContent: 'space-between', alignItems: 'center' }}>
                {activeFormStep !== 0 ? (
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={handleBack}
                        sx={{
                            textTransform: 'none',
                            px: 2,
                            py: 0.8,
                            fontSize: '0.85rem',
                            borderRadius: '8px',
                            borderColor: 'primary.main',
                            color: 'primary.main',
                            fontWeight: 500,
                            minWidth: 90,
                            '&:hover': {
                                borderColor: 'primary.dark',
                                backgroundColor: 'rgba(25, 118, 210, 0.04)',
                            },
                        }}
                    >
                        Back
                    </Button>
                ) : (
                    <Box />
                )}

                <Box sx={{ flex: 1 }} />

                {activeFormStep !== steps.length - 1 && activeFormStep !== 0 && (
                    <Button
                        variant="contained"
                        size="small"
                        onClick={handleNext}
                        sx={{
                            textTransform: 'none',
                            px: 2,
                            py: 0.8,
                            fontSize: '0.85rem',
                            borderRadius: '8px',
                            fontWeight: 500,
                            minWidth: 90,
                            boxShadow: 'none',
                            backgroundColor: 'primary.main',
                            '&:hover': {
                                backgroundColor: 'primary.dark',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                            },
                        }}
                    >
                        Next
                    </Button>
                )}

                {activeFormStep === steps.length - 1 && (
                    <>
                        {/* <Button
                            variant="contained"
                            size="small"
                            // onClick={handleFile24Q}
                            sx={{
                                textTransform: 'none',
                                px: 2,
                                py: 0.8,
                                fontSize: '0.85rem',
                                borderRadius: '8px',
                                fontWeight: 500,
                                minWidth: 90,
                                boxShadow: 'none',
                                backgroundColor: 'primary.main',
                                '&:hover': {
                                    backgroundColor: 'primary.dark',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                },
                            }}
                        >
                            Reset
                        </Button> */}
                        <Button
                            variant="contained"
                            size="small"
                            onClick={handleGenerateFUVFile}
                            disabled={isFUVGenerating || isViewOnly}
                            sx={{
                                textTransform: 'none',
                                px: 2,
                                py: 0.8,
                                fontSize: '0.85rem',
                                borderRadius: '8px',
                                fontWeight: 500,
                                minWidth: 90,
                                boxShadow: 'none',
                                backgroundColor: 'primary.main',
                                '&:hover': {
                                    backgroundColor: 'primary.dark',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                },
                                '&:disabled': {
                                    backgroundColor: 'primary.light',
                                    color: '#fff',
                                },
                            }}
                        >
                            {isFUVGenerating ? 'Generating...' : 'Generate FUV File'}
                        </Button>
                        <Button
                            variant="contained"
                            size="small"
                            onClick={handleFile24Q}
                            disabled={isViewOnly}
                            sx={{
                                textTransform: 'none',
                                px: 2,
                                py: 0.8,
                                fontSize: '0.85rem',
                                borderRadius: '8px',
                                fontWeight: 500,
                                minWidth: 90,
                                boxShadow: 'none',
                                backgroundColor: 'primary.main',
                                '&:hover': {
                                    backgroundColor: 'primary.dark',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                },
                            }}
                        >
                            File 24Q
                        </Button>
                    </>
                )}
            </Stack>

            <Dialog
                open={autoDownloadOpen}
                onClose={handleCloseAutoDownload}
                maxWidth="xs"
                fullWidth
                PaperProps={{ sx: { borderRadius: '10px', overflow: 'hidden' } }}
            >
                <DialogTitle
                    sx={{
                        backgroundColor: '#0d3f66',
                        color: '#ffffff',
                        fontWeight: 700,
                        fontSize: '18px',
                        py: 2,
                        px: 3,
                    }}
                >
                    Auto Download
                    <IconButton
                        onClick={handleCloseAutoDownload}
                        sx={{ position: 'absolute', right: 12, top: 12, color: '#ffffff' }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ px: 3, pt: 3, pb: 1 }}>
                    <Box sx={{ mt: 1 }}>
                        <label style={{
                            display: 'block',
                            marginBottom: '6px',
                            fontSize: '12px',
                            fontWeight: 700,
                            textTransform: 'uppercase',
                            color: '#4b5563',
                            letterSpacing: '0.3px',
                        }}>
                            Phone Number <span style={{ color: 'red' }}>*</span>
                        </label>
                        <TextField
                            fullWidth
                            size="small"
                            variant="outlined"
                            placeholder="Enter Phone Number"
                            value={autoDownloadPhone}
                            onChange={(e) => setAutoDownloadPhone(e.target.value)}
                            inputProps={{ maxLength: 10 }}
                            disabled={otpSent}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Box>

                    {otpSent && (
                        <Box sx={{ mt: 3 }}>
                            <label style={{
                                display: 'block',
                                marginBottom: '6px',
                                fontSize: '12px',
                                fontWeight: 700,
                                textTransform: 'uppercase',
                                color: '#4b5563',
                                letterSpacing: '0.3px',
                            }}>
                                Enter OTP <span style={{ color: 'red' }}>*</span>
                            </label>
                            <TextField
                                fullWidth
                                size="small"
                                variant="outlined"
                                value={otpValue}
                                onChange={(e) => setOtpValue(e.target.value)}
                                inputProps={{ maxLength: 6 }}
                                placeholder="Enter OTP"
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                            />
                            <Button
                                variant="text"
                                size="small"
                                onClick={handleSendOtp}
                                disabled={isSendingOtp}
                                sx={{ textTransform: 'none', mt: 1, color: '#0d3f66', fontWeight: 600 }}
                            >
                                Resend OTP
                            </Button>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions sx={{ px: 3, py: 2.5, borderTop: '1px solid #e5e7eb' }}>
                    {!otpSent ? (
                        <Button
                            variant="contained"
                            onClick={handleSendOtp}
                            disabled={isSendingOtp}
                            sx={{
                                textTransform: 'none',
                                fontWeight: 600,
                                backgroundColor: '#0d3f66',
                                borderRadius: '8px',
                                px: 3,
                                '&:hover': { backgroundColor: '#0a2f4e' },
                            }}
                        >
                            {isSendingOtp ? 'Sending...' : 'Send OTP'}
                        </Button>
                    ) : (
                        <Button
                            variant="contained"
                            onClick={handleSubmitOtp}
                            disabled={isSubmittingOtp}
                            sx={{
                                textTransform: 'none',
                                fontWeight: 600,
                                backgroundColor: '#0d3f66',
                                borderRadius: '8px',
                                px: 3,
                                '&:hover': { backgroundColor: '#0a2f4e' },
                            }}
                        >
                            {isSubmittingOtp ? 'Submitting...' : 'Submit'}
                        </Button>
                    )}
                    <Button
                        variant="outlined"
                        onClick={handleCloseAutoDownload}
                        sx={{
                            textTransform: 'none',
                            fontWeight: 600,
                            color: '#0d3f66',
                            borderColor: '#0d3f66',
                            borderRadius: '8px',
                            px: 3,
                            '&:hover': { borderColor: '#0a2f4e', backgroundColor: 'rgba(13,63,102,0.04)' },
                        }}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default Form24QFiling;